import './blocks/faq/front';
import './blocks/video-popup/front';
import './blocks/content-toggle/front';

let mobile = false;
function isMobile() {
    if ( window.innerWidth < 1180 ) {
        mobile = true;
    } else {
        mobile = false;
    }
}

window.addEventListener( 'load', function() {
    isMobile();
    overflowRightLeft();
} );

window.addEventListener( 'resize', function() {
    isMobile();
    overflowRightLeft();
} );

// bloc overflow right/left
function overflowRightLeft() {
    const blocksOverflow = document.querySelectorAll( '.pull--right, .pull--left' );
    if ( blocksOverflow ) {
        [...blocksOverflow].forEach( blockOverflow => {
            const img = blockOverflow.querySelector( 'img' );
            if ( img ) {
                const src = img.getAttribute( 'data-lazy-src' ) || img.currentSrc;
                if ( src ) {
                    if ( ! mobile ) {
                        blockOverflow.style.backgroundImage = 'url("' + src + '")';
                        img.style.display = 'none';
                    } else {
                        blockOverflow.style.backgroundImage = 'none';
                        img.style.display = 'block';
                    }
                }
            }
        } );
    }
}

/*
function overflowRightLeft() {
    const blocksOverflow = document.querySelectorAll( '.pull--right, .pull--left' );
    if ( blocksOverflow ) {
        [...blocksOverflow].forEach( blockOverflow => {
            const img = blockOverflow.querySelector( 'img' );
            if ( img && img.currentSrc ) {
                if ( ! mobile ) {
                    console.log(img)
                    const imgHeight = blockOverflow.clientHeight;
                    let newImgHeight = imgHeight * 1.5;
                    let imgTop = imgHeight - newImgHeight;
                    img.style.height = newImgHeight + 'px';
                    img.style.marginTop = imgTop / 2 + 'px';
                } else {
                    img.style.height = '100%';
                    img.style.top = 0;
                }
            }
        } );
    }
}*/